import { api, LightningElement } from "lwc";

export default class extends LightningElement {
  // In the future, this could accept a value of "auto" which
  // could traverse the DOM tree and figure out the appropriate level
  @api level: "1" | "2" | "3" | "4" | "5" | "6" | null = null;
  @api displayLevel: "1" | "2" | "3" | "4" | "5" | "6" | "unset" | null = null;

  private get isHeading() {
    // If "level" is null, we render a <slot> and with no heading
    return typeof this.level === "string";
  }

  private get className() {
    if (this.displayLevel === "unset") return null;
    return `h${this.displayLevel ?? this.level}`;
  }

  private get isLevel1() {
    return this.level === "1";
  }

  private get isLevel2() {
    return this.level === "2";
  }

  private get isLevel3() {
    return this.level === "3";
  }

  private get isLevel4() {
    return this.level === "4";
  }

  private get isLevel5() {
    return this.level === "5";
  }

  private get isLevel6() {
    return this.level === "6";
  }
}
